module.exports = __webpack_public_path__ + "static/media/Quito.902c3dd2.webp";